import { Alert } from '@mui/material';
import { EnhancedCard } from 'components/enhanced/card';
import { currencyFormatter } from 'components/helpers/currency-formatter';
import { useTranslation } from 'react-i18next';
import InvoiceUpdateForm from '../form/InvoiceUpdateForm';
import { IInvoice } from '../../types';

const TRANSLATION_PREFIX = 'pages.invoices.update';
interface InvoiceBaseInfoProps {
  invoice: IInvoice;
  openErrorColor: boolean;
  updateInvoice;
}
export const InvoiceBaseInfo = ({
  invoice,
  openErrorColor,
  updateInvoice
}: InvoiceBaseInfoProps) => {
  const { t } = useTranslation();

  return (
    <>
      {invoice && invoice.amount != null && +invoice.amount !== +invoice.expected_amount && (
        <>
          <Alert severity="warning" sx={{ width: '100%', mb: 3, borderRadius: 2 }}>
            {t(`${TRANSLATION_PREFIX}.incoerent-amounts`)}
          </Alert>
          <div className="grid grid-cols-2 gap-6 ">
            <EnhancedCard
              title={t(`entities.ddt.amount`)}
              subtitle={currencyFormatter(invoice.amount)}
            />
            <EnhancedCard
              title={t(`${TRANSLATION_PREFIX}.invoice-expected`)}
              subtitle={currencyFormatter(invoice.expected_amount)}
            />
          </div>
        </>
      )}
      <InvoiceUpdateForm
        invoice={invoice}
        openErrorColor={openErrorColor}
        updateInvoice={updateInvoice}
      />
    </>
  );
};
